module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/pria/assets/img/arrow-right.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/pria/assets/img/arrow-right.png
// module id = 214
// module chunks = 418